// Към коя минута „залепва" плъзгачът на времевата линия (тестове:
// timelineSnap.test.ts).

import { TIMELINE_STEP_MINUTES, type TimelineRange } from "./dayTime";

// „Сега" привлича в този обхват — пуснат там, плъзгачът пак следва живия час.
const NOW_MAGNET_MINUTES = 4;
// Маркер (началото на резервация) привлича в този обхват, но само ако е
// по-близо от най-близката кръгла стъпка — иначе около маркер в 19:02
// стъпките 19:00 и 19:05 не биха се избирали с плъзгане.
const MARKER_MAGNET_MINUTES = 4;

/**
 * Суровата минута под пръста → стойността на плъзгача: „сега" (в днешния
 * ден), после най-близкият маркер, ако е по-близо от стъпката, иначе
 * кръглата стъпка от `TIMELINE_STEP_MINUTES`, в обхвата на линията.
 */
export const snapTimelineMinute = (
  raw: number,
  { range, liveMinute, markerMinutes }: { range: TimelineRange; liveMinute: number | null; markerMinutes: number[] },
): number => {
  if (liveMinute !== null && Math.abs(liveMinute - raw) <= NOW_MAGNET_MINUTES) return liveMinute;
  const step = Math.min(
    range.endMinute,
    Math.max(range.startMinute, Math.round(raw / TIMELINE_STEP_MINUTES) * TIMELINE_STEP_MINUTES),
  );
  let nearest: number | null = null;
  for (const minute of markerMinutes) {
    if (nearest === null || Math.abs(minute - raw) < Math.abs(nearest - raw)) nearest = minute;
  }
  if (nearest === null) return step;
  const markerDistance = Math.abs(nearest - raw);
  return markerDistance <= MARKER_MAGNET_MINUTES && markerDistance < Math.abs(step - raw) ? nearest : step;
};
